import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PortalMaterialidadShell from "./PortalMaterialidadShell";

export default function PortalMaterialidadHomePage() {
  return (
    <PortalMaterialidadShell>
      <div className="space-y-6" data-testid="portal-materialidad-home">
        <div>
          <h1 className="text-3xl font-semibold tracking-tight text-[#0F2D5C]">
            Portal de clientes
          </h1>
          <p className="mt-2 text-sm text-slate-600 max-w-xl">
            Consulte sus empresas y cargue la documentación que su despacho le solicita.
            Este acceso es independiente del sistema interno del despacho.
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Button asChild className="rounded-sm" data-testid="portal-go-login">
            <Link to="/portal-materialidad/login">Iniciar sesión</Link>
          </Button>
        </div>
        <p className="text-xs text-slate-500">
          Si recibió un enlace seguro por correo o WhatsApp, ábralo para cargar solo esa solicitud.
        </p>
      </div>
    </PortalMaterialidadShell>
  );
}
